import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { PrimaryButton, styleVariables } from '@lib/common';
import { Col, Row } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledDefaultTitle = styled.span.withConfig({
  displayName: "assignment-detail-headercomponent__StyledDefaultTitle",
  componentId: "sc-zr9evf-0"
})(["font-weight:700;font-size:24px;line-height:32px;"]);
var StyledContentItem = styled.div.withConfig({
  displayName: "assignment-detail-headercomponent__StyledContentItem",
  componentId: "sc-zr9evf-1"
})(["display:flex;justify-content:center;align-items:center;font-size:12px;background:", ";border:1px solid ", ";border-radius:8px;padding:8px 16px;", ""], styleVariables.colors.gray1, styleVariables.colors.gray7, function (props) {
  return props.theme.media.desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 16px;\n  "])));
});
var StyledRedoAssignmentButton = styled(PrimaryButton).withConfig({
  displayName: "assignment-detail-headercomponent__StyledRedoAssignmentButton",
  componentId: "sc-zr9evf-2"
})(["", ""], function (props) {
  return props.theme.media.mobile(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: 12px;\n  "])));
});
var StyledText = styled.span.withConfig({
  displayName: "assignment-detail-headercomponent__StyledText",
  componentId: "sc-zr9evf-3"
})(["font-weight:600;color:", ";"], styleVariables.colors.blue4);
var Wrapper = styled.div.withConfig({
  displayName: "assignment-detail-headercomponent__Wrapper",
  componentId: "sc-zr9evf-4"
})(["width:100%;display:flex;flex-direction:column;justify-content:space-between;", ""], function (props) {
  return props.theme.media.desktop(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    flex-direction: row;\n  "])));
});
var ButtonLayout = styled.div.withConfig({
  displayName: "assignment-detail-headercomponent__ButtonLayout",
  componentId: "sc-zr9evf-5"
})(["display:flex;gap:16px;align-items:center;justify-content:space-between;"]);
export var AssignmentDetailHeaderComponent = function AssignmentDetailHeaderComponent(_ref) {
  var translation = _ref.translation,
      submissionsResponse = _ref.submissionsResponse,
      showRedoButton = _ref.showRedoButton,
      onRedoAssignment = _ref.onRedoAssignment,
      isLoadingCreateSubmission = _ref.isLoadingCreateSubmission;
  return /*#__PURE__*/_jsx(Row, {
    style: {
      marginBottom: '16px'
    },
    children: /*#__PURE__*/_jsx(Col, {
      span: 24,
      children: /*#__PURE__*/_jsxs(Wrapper, {
        children: [/*#__PURE__*/_jsx(StyledDefaultTitle, {
          children: translation.assignmentDetail
        }), /*#__PURE__*/_jsxs(ButtonLayout, {
          children: [/*#__PURE__*/_jsxs(StyledContentItem, {
            children: [translation.totalOfSubmittedSubmission, ":\xA0\xA0\xA0", /*#__PURE__*/_jsx(StyledText, {
              children: submissionsResponse.length
            })]
          }), showRedoButton && /*#__PURE__*/_jsx(StyledRedoAssignmentButton, {
            onClick: onRedoAssignment,
            disabled: isLoadingCreateSubmission,
            loading: isLoadingCreateSubmission,
            children: translation.doPracticeAgain
          })]
        })]
      })
    })
  });
};